export default __webpack_public_path__ + "static/media/facebook_logo.bf608975.svg";